import WalletController from "../controller/walletController";

/**
 * Broadcast wallet/balance updates to all listening pages (mirrors Flutter EWalletController.update()).
 */
export function emitWalletSyncEvents({
  title = "",
  notificationCount,
  chatNotificationCount,
} = {}) {
  try {
    window.dispatchEvent(new Event("dashboard:refresh"));
  } catch (_) {}

  try {
    window.dispatchEvent(new Event("ib-dashboard:refresh"));
  } catch (_) {}

  try {
    window.dispatchEvent(
      new CustomEvent("mfg:funds-refresh", {
        detail: { title: String(title || ""), at: Date.now() },
      })
    );
  } catch (_) {}

  if (notificationCount != null) {
    try {
      window.dispatchEvent(
        new CustomEvent("mfg:notification-badge", {
          detail: { count: Math.max(0, Number(notificationCount) || 0) },
        })
      );
    } catch (_) {}
  }

  if (chatNotificationCount != null) {
    try {
      window.dispatchEvent(
        new CustomEvent("mfg:chat-notification-badge", {
          detail: { count: Math.max(0, Number(chatNotificationCount) || 0) },
        })
      );
    } catch (_) {}
  }
}

/**
 * Refresh cached wallet balances then notify all subscribers (mirrors Flutter handlerMessage tail).
 * @returns {Promise<object|null>}
 */
export async function syncWalletsAfterNotification({ title = "" } = {}) {
  let result = null;
  try {
    result = await WalletController.refreshWalletsCache();
  } catch (_) {}

  emitWalletSyncEvents({
    title,
    notificationCount: result?.notificationCount,
    chatNotificationCount: result?.chatNotificationCount,
  });

  return result;
}
